export default __webpack_public_path__ + "static/bisolviralkutu-335e017a903a275bd8c2ec5e134e5af5.png";